import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";
export function cn(...inputs) {
    return twMerge(clsx(inputs));
}
export function handlePreviewClick(e) {
    const target = e.target;
    if (target.tagName === "A" ||
        (target.tagName === "BUTTON" && target.getAttribute("type") !== "button")) {
        e.preventDefault();
    }
}
